import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const ProductCategoryForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'productcategory'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'productcategory.general.name_label',
            type: 'text',
            placeholder: 'productcategory.general.name_placeholder',
        },
        { 
            type: 'dropdown', 
            name: 'ledger_account', 
            label: 'productcategory.general.ledger_account_label', 
            apiRequest: [{
                endpoint: 'get_ledgeraccount_list',
                object: 'ledgeraccount',
                params: { is_active: true, ledger_account_type: 'revenue' },
                useCache: true
            }],
            disabled_selected: 'productcategory.general.ledger_account_disabled_selected',
        },        
        { 
            type: 'dropdown', 
            name: 'pricing_method', 
            label: 'productcategory.general.pricing_method_label', 
            tooltipText: 'productcategory.general.pricing_method_tooltipText',
            disabled_selected: 'forms.select_type_disabled_selected',
            defaultValue: { value: 'per_unit' },
            allowNoneOption: false,
            showSearch: false,
            activeFeature: 'dimension_pricing',
            hardcodedOptions: [
                { value: 'per_unit', name: 'product.pricing_method.per_unit' },
                { value: 'dimensions', name: 'product.pricing_method.dimensions' },
            ],
        },
        { 
            type: 'dropdown', 
            name: 'visibility', 
            label: 'productcategory.general.visibility_label', 
            tooltipText: 'productcategory.general.visibility_tooltipText',
            disabled_selected: 'forms.select_type_disabled_selected',
            defaultValue: { value: 'whole_company' },
            allowNoneOption: false,
            showSearch: false,
            hardcodedOptions: [
                { value: 'whole_company', name: 'productcategory.visibility.whole_company'},
                { value: 'only_office', name: 'productcategory.visibility.only_office'},
            ],
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default ProductCategoryForm;